import { useEffect, type ReactNode } from 'react';

export function Modal({
  open, title, onClose, children, width = 520,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  width?: number;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    // Lock body scroll
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: width }}
        className="w-full h-full sm:h-auto sm:max-h-[90vh] sm:rounded-lg bg-ink-card border border-ink-border p-5 sm:p-6 overflow-auto"
      >
        <div className="flex items-center justify-between mb-4 sticky -top-5 sm:-top-6 -mx-5 sm:-mx-6 px-5 sm:px-6 py-3 bg-ink-card border-b border-ink-border">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button onClick={onClose}
                  className="text-ink-muted hover:text-ink-text text-2xl leading-none p-1 -m-1"
                  aria-label="Close">×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function Field({ label, hint, children }: { label: string; hint?: string; children: ReactNode }) {
  return (
    <label className="block mb-3">
      <div className="text-xs text-ink-muted mb-1.5 font-medium">
        {label}{hint && <span className="text-ink-muted/70 ml-1 font-normal">({hint})</span>}
      </div>
      {children}
    </label>
  );
}

export const inputCls =
  'w-full px-3 py-2 bg-ink-bg border border-ink-border text-ink-text rounded text-sm focus:outline-none focus:border-brand-600';
